export default "__VITE_ASSET__mvaOD0C1__"